import { Loading } from "element-ui";
import { useShowErrorMessage } from "./use-notifications";

function triggerDownload(href: string, filename: string) {
  try {
    const link = document.createElement("a");
    link.href = href;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    useShowErrorMessage("Failed", "Failed to download file");
  }
}

export default async function (
  fileLink: string,
  fileName?: string
): Promise<void> {
  const ext = fileLink.split(".").pop() ?? "";
  const name = fileName ? `${fileName}.${ext}` : "";

  let loader: ReturnType<typeof Loading.service> | undefined;

  try {
    if (
      fileName &&
      //@ts-expect-error - This condition will always return true since this function is always defined...
      window.fetch &&
      window.Blob &&
      window.URL &&
      URL.createObjectURL
    ) {
      loader = Loading.service({
        lock: true,
        text: "Downloading...",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const response = await fetch(fileLink);
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      triggerDownload(blobUrl, name);
      URL.revokeObjectURL(blobUrl);
    } else {
      // Fallback for browsers without Blob support
      triggerDownload(fileLink, name || "file");
    }
  } catch (err) {
    // Fallback for browsers without Blob support
    triggerDownload(fileLink, name || "file");
  } finally {
    loader?.close();
  }
}
